<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" align="center" fixed="right" width="95">
          <template slot-scope="{row}">
            <template v-if="row.Status<2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="editById(row.OtherReceivId)">编辑</el-button>
              </template>
              <template v-if="$permission.canReview()">
                <el-button type="text" @click.stop="review(row.OtherReceivId)">审核</el-button>
              </template>
            </template>
            <el-button type="text" v-else @click.stop="details(row.OtherReceivId)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>单据明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details" v-loading="isLoading" show-summary>
      <el-table-column label="摘要" align="center" min-width="200">
        <template slot-scope="{row}">{{row.Abstract}}</template>
      </el-table-column>
      <el-table-column label="项目" align="center" min-width="140">
        <template slot-scope="{row}">{{row.ItemName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" align="center" width="120" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/orec/list";
import editDialog from "@/components/finance/dealings/orec/editDialog";
import detailsDialog from "@/components/finance/dealings/orec/detailsDialog";

export default {
  name: "orec",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
  },
  data() {
    return {
      // api: require("@/api/rp/otherReceivDts").default,
      api: require("@/api/rp/otherReceiv").default,
      Details: [],
      isLoading: false,
    };
  },
  methods: {
    reload() {
      this.$refs.list.reload();
      this.Details = [];
    },
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.Details = [];
      this.isLoading = true;
      this.api.info(row.OtherReceivId).then((res) => {
        this.isLoading = false;
        if (res.Code == 0) this.Details = res.Data.RpOtherReceivDts;
      });
    },
    details(id) {
      this.$refs.detailsDialog.openDetailsById(id);
    },
    review(id) {
      this.$refs.detailsDialog.openEditById(id);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.OtherReceivId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>